.editable-textbox {
  flex: 1;
}

.editable-textbox.no-line-break {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.editable-textbox.no-line-break:focus {
  text-overflow: clip;
}

.editable-textbox:empty:not(:focus)::before {
  content: attr(data-placeholder);
  color: grey;
}

.editable-textbox.light-border {
  border: 1px solid transparent;
  border-radius: 2px;
  outline: 0;

  transition: border-color 200ms ease-out;
  color: #efefef;
}

.editable-textbox.light-border:focus {
  border-color: #e9e9e9;
  cursor: text;
}
